import { setStoreValue } from '@/store/modules/storeHelpers';
import EventBus from '@/helpers/event-bus';
import HTTP from '@/services/HTTP';

const state = {
    data: {},
    selectedCompaniesId: [],
};

const actions = {
    async register(_, credentials) {
        try {
            const { data } = await HTTP.post('auth/register', credentials);
            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'User created - need jwt');
                return true;
            }
        } catch (error) {
            if (error.response.data.errors.length) {
                EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
                return false;
            }
        }
    },
    async login({ commit, dispatch }, credentials) {
        try {
            const { data } = await HTTP.post('auth/login', credentials);

            if (data && data.status === 1) {
                await commit('user/storeToken', data.jwt, { root: true });
                await dispatch('user/getUserInfo', null, { root: true });
                EventBus.$emit('snotifySuccess', 'User logedin');
                return true;
            }
        } catch (error) {
            if (error.response.data.errors.length) {
                EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
            }
        }
    }
};

const mutations = {
    setAuthData(state, data) {
        state.data = data;
    },
    setStoreValue,
};

/**
 * Main app store data
 */
export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
